const brandModelData = Object.fromEntries(
  Object.entries({
"Apple":[
    {
      "code": "5",
      "name": "5"
    },
    {
      "code": "5s",
      "name": "5s"
    },
    {
      "code": "6",
      "name": "6"
    },
    {
      "code": "6_plus",
      "name": "6 Plus"
    },
    {
      "code": "7",
      "name": "7"
    },
    {
      "code": "7_plus",
      "name": "7 Plus"
    },
    {
      "code": "8",
      "name": "8"
    },
    {
      "code": "8_plus",
      "name": "8 Plus"
    },
    {
      "code": "x",
      "name": "X"
    },
    {
      "code": "xr",
      "name": "XR"
    },
    {
      "code": "xs",
      "name": "XS"
    },
    {
      "code": "xs_max",
      "name": "XS Max"
    },
    {
      "code": "11",
      "name": "11"
    },
    {
      "code": "11_pro",
      "name": "11 Pro"
    },
    {
      "code": "11_pro_max",
      "name": "11 Pro Max"
    },
    {
      "code": "12",
      "name": "12"
    },
    {
      "code": "12_mini",
      "name": "12 Mini"
    },
    {
      "code": "12_pro",
      "name": "12 Pro"
    },
    {
      "code": "12_pro_max",
      "name": "12 Pro Max"
    },
    {
      "code": "13",
      "name": "13"
    },
    {
      "code": "13_mini",
      "name": "13 Mini"
    },
    {
      "code": "13_pro",
      "name": "13 Pro"
    },
    {
      "code": "13_pro_max",
      "name": "13 Pro Max"
    },
    {
      "code": "14",
      "name": "14"
    },
    {
      "code": "14_plus",
      "name": "14 Plus"
    },
    {
      "code": "14_pro",
      "name": "14 Pro"
    },
    {
      "code": "14_pro_max",
      "name": "14 Pro Max"
    },
    {
      "code": "15",
      "name": "15"
    },
    {
      "code": "15_plus",
      "name": "15 Plus"
    },
    {
      "code": "15_pro",
      "name": "15 Pro"
    },
    {
      "code": "15_pro_max",
      "name": "15 Pro Max"
    },
    {
      "code": "16",
      "name": "16"
    },
    {
      "code": "16_plus",
      "name": "16 Plus"
    },
    {
      "code": "16_pro",
      "name": "16 Pro"
    },
    {
      "code": "16_pro_max",
      "name": "16 Pro Max"
    },
    {
      "code": "16e",
      "name": "16e"
    },
    {
      "code": "Air",
      "name": "Air"
    },
    {
      "code": "17",
      "name": "17"
    },
    {
      "code": "17 Pro",
      "name": "17 Pro"
    },
    {
      "code": "17 Pro Max",
      "name": "17 Pro Max"
    },
  ],
"Samsung": [
  {
    "code": "f14_4g",
    "name": "Galaxy F14 4G"
  },
  {
    "code": "f15_5g",
    "name": "Galaxy F15 5G"
  },
  {
    "code": "f16_5g",
    "name": "Galaxy F16 5G"
  },
  {
    "code": "f24_5g",
    "name": "Galaxy F24 5G"
  },
  {
    "code": "f35_5g",
    "name": "Galaxy F35 5G"
  },
  {
    "code": "f55_5g",
    "name": "Galaxy F55 5G"
  },
  {
    "code": "fold_1",
    "name": "Galaxy Fold 1"
  },
  {
    "code": "fold_2",
    "name": "Galaxy Fold 2"
  },
  {
    "code": "fold_3",
    "name": "Galaxy Fold 3"
  },
  {
    "code": "fold_4",
    "name": "Galaxy Fold 4"
  },
  {
    "code": "fold_5",
    "name": "Galaxy Fold 5"
  },
  {
    "code": "fold_6",
    "name": "Galaxy Fold 6"
  },
  {
    "code": "galaxy_a05",
    "name": "Galaxy A05"
  },
  {
    "code": "galaxy_a05s",
    "name": "Galaxy A05s"
  },
  {
    "code": "galaxy_a14",
    "name": "Galaxy A14"
  },
  {
    "code": "galaxy_a15_5g",
    "name": "Galaxy A15 5G"
  },
  {
    "code": "galaxy_a16",
    "name": "Galaxy A16"
  },
  {
    "code": "galaxy_a16_4g",
    "name": "Galaxy A16 4G"
  },
  {
    "code": "galaxy_a16_5g",
    "name": "Galaxy A16 5G"
  },
  {
    "code": "galaxy_a26_5g",
    "name": "Galaxy A26 5G"
  },
  {
    "code": "galaxy_a35_5g",
    "name": "Galaxy A35 5G"
  },
  {
    "code": "galaxy_a36_5g",
    "name": "Galaxy A36 5G"
  },
  {
    "code": "galaxy_a55_5g",
    "name": "Galaxy A55 5G"
  },
  {
    "code": "galaxy_a56_5g",
    "name": "Galaxy A56 5G"
  },
  {
    "code": "galaxy_m15_5g",
    "name": "Galaxy M15 5G"
  },
  {
    "code": "galaxy_m16_5g",
    "name": "Galaxy M16 5G"
  },
  {
    "code": "galaxy_m34_5g",
    "name": "Galaxy M34 5G"
  },
  {
    "code": "galaxy_m35_5g",
    "name": "Galaxy M35 5G"
  },
  {
    "code": "m14_4g",
    "name": "Galaxy M14 4G"
  },
  {
    "code": "note_8",
    "name": "Galaxy Note 8"
  },
  {
    "code": "note_9",
    "name": "Galaxy Note 9"
  },
  {
    "code": "note_10",
    "name": "Galaxy Note 10"
  },
  {
    "code": "note_10_lite",
    "name": "Galaxy Note 10 Lite"
  },
  {
    "code": "note_10_plus",
    "name": "Galaxy Note 10 Plus"
  },
  {
    "code": "note_20",
    "name": "Galaxy Note 20"
  },
  {
    "code": "note_20_ultra",
    "name": "Galaxy Note 20 Ultra"
  },
  {
    "code": "s8",
    "name": "Galaxy S8"
  },
  {
    "code": "s8_plus",
    "name": "Galaxy S8 Plus"
  },
  {
    "code": "s9",
    "name": "Galaxy S9"
  },
  {
    "code": "s9_plus",
    "name": "Galaxy S9 Plus"
  },
  {
    "code": "s10",
    "name": "Galaxy S10"
  },
  {
    "code": "s10_e",
    "name": "Galaxy S10e"
  },
  {
    "code": "s10_lite",
    "name": "Galaxy S10 Lite"
  },
  {
    "code": "s10_plus",
    "name": "Galaxy S10 Plus"
  },
  {
    "code": "s20",
    "name": "Galaxy S20"
  },
  {
    "code": "s20_fe",
    "name": "Galaxy S20 FE"
  },
  {
    "code": "s20_plus",
    "name": "Galaxy S20 Plus"
  },
  {
    "code": "s20_ultra",
    "name": "Galaxy S20 Ultra"
  },
  {
    "code": "s21",
    "name": "Galaxy S21"
  },
  {
    "code": "s21_fe",
    "name": "Galaxy S21 FE"
  },
  {
    "code": "s21_plus",
    "name": "Galaxy S21 Plus"
  },
  {
    "code": "s21_ultra",
    "name": "Galaxy S21 Ultra"
  },
  {
    "code": "s22",
    "name": "Galaxy S22"
  },
  {
    "code": "s22_plus",
    "name": "Galaxy S22 Plus"
  },
  {
    "code": "s22_ultra",
    "name": "Galaxy S22 Ultra"
  },
  {
    "code": "s23",
    "name": "Galaxy S23"
  },
  {
    "code": "s23_fe",
    "name": "Galaxy S23 FE"
  },
  {
    "code": "s23_plus",
    "name": "Galaxy S23 Plus"
  },
  {
    "code": "s23_ultra",
    "name": "Galaxy S23 Ultra"
  },
  {
    "code": "s24",
    "name": "Galaxy S24"
  },
  {
    "code": "s24_fe",
    "name": "Galaxy S24 FE"
  },
  {
    "code": "s24_plus",
    "name": "Galaxy S24 Plus"
  },
  {
    "code": "s24_ultra",
    "name": "Galaxy S24 Ultra"
  },
  {
    "code": "s25",
    "name": "Galaxy S25"
  },
  {
    "code": "s25_plus",
    "name": "Galaxy S25 Plus"
  },
  {
    "code": "s25_ultra",
    "name": "Galaxy S25 Ultra"
  },
  {
    "code": "z_flip",
    "name": "Galaxy Z Flip"
  },
  {
    "code": "z_flip_3",
    "name": "Galaxy Z Flip 3"
  },
  {
    "code": "z_flip_4",
    "name": "Galaxy Z Flip 4"
  },
  {
    "code": "z_flip_5",
    "name": "Galaxy Z Flip 5"
  },
  {
    "code": "z_flip_6",
    "name": "Galaxy Z Flip 6"
  }
],
"OnePlus": [
  { "code": "5", "name": "OnePlus 5" },
  { "code": "5t", "name": "OnePlus 5T" },
  { "code": "6", "name": "OnePlus 6" },
  { "code": "6t", "name": "OnePlus 6T" },
  { "code": "7", "name": "OnePlus 7" },
  { "code": "7t", "name": "OnePlus 7T" },
  { "code": "7_pro", "name": "OnePlus 7 Pro" },
  { "code": "7t_pro", "name": "OnePlus 7T Pro" },
  { "code": "8", "name": "OnePlus 8" },
  { "code": "8_pro", "name": "OnePlus 8 Pro" },
  { "code": "8t", "name": "OnePlus 8T" },
  { "code": "9", "name": "OnePlus 9" },
  { "code": "9r", "name": "OnePlus 9R" },
  { "code": "9_pro", "name": "OnePlus 9 Pro" },
  { "code": "9rt", "name": "OnePlus 9RT" },
  { "code": "10_pro", "name": "OnePlus 10 Pro" },
  { "code": "10r", "name": "OnePlus 10R" },
  { "code": "10t", "name": "OnePlus 10T" },
  { "code": "11", "name": "OnePlus 11" },
  { "code": "11r", "name": "OnePlus 11R" },
  { "code": "12", "name": "OnePlus 12" },
  { "code": "12r", "name": "OnePlus 12R" },
  { "code": "13", "name": "OnePlus 13" },
  { "code": "13r", "name": "OnePlus 13R" },
  { "code": "open", "name": "OnePlus Open" },

  { "code": "nord", "name": "OnePlus Nord" },
  { "code": "nord_ce", "name": "OnePlus Nord CE" },
  { "code": "nord_ce_2", "name": "OnePlus Nord CE 2" },
  { "code": "nord_ce_2_lite", "name": "OnePlus Nord CE 2 Lite" },
  { "code": "nord_ce_3", "name": "OnePlus Nord CE 3" },
  { "code": "nord_ce_3_lite", "name": "OnePlus Nord CE 3 Lite" },
  { "code": "nord_ce_4", "name": "OnePlus Nord CE 4" },
  { "code": "nord_ce_4_lite", "name": "OnePlus Nord CE 4 Lite" },
  { "code": "nord_2_5g", "name": "OnePlus Nord 2 5G" },
  { "code": "nord_2t", "name": "OnePlus Nord 2T" },
  { "code": "nord_3", "name": "OnePlus Nord 3" },
  { "code": "nord_4", "name": "OnePlus Nord 4" },
  { "code": "nord_n10", "name": "OnePlus Nord N10" },
  { "code": "nord_n100", "name": "OnePlus Nord N100" },
  { "code": "nord_n200", "name": "OnePlus Nord N200" },
  { "code": "nord_n20", "name": "OnePlus Nord N20" }
],
"Xiaomi": [
  { "code": "poco_c71", "name": "Poco C71" },
  { "code": "poco_c75", "name": "Poco C75" },
  { "code": "poco_c55", "name": "Poco C55" },
  { "code": "poco_f5_5g", "name": "Poco F5 5G" },
  { "code": "poco_f6", "name": "Poco F6" },
  { "code": "poco_m4_pro_5g", "name": "Poco M4 Pro 5G" },
  { "code": "poco_m5", "name": "Poco M5" },
  { "code": "poco_m6_5g", "name": "Poco M6 5G" },
  { "code": "poco_m6_pro_5g", "name": "Poco M6 Pro 5G" },
  { "code": "poco_m7_5g", "name": "Poco M7 5G" },
  { "code": "poco_m7_pro_5g", "name": "Poco M7 Pro 5G" },
  { "code": "poco_x4_gt", "name": "Poco X4 GT" },
  { "code": "poco_x4_prp_5g", "name": "Poco X4 PRP 5G" },
  { "code": "poco_x5_5g", "name": "Poco X5 5G" },
  { "code": "poco_x5_pro_5g", "name": "Poco X5 Pro 5G" },
  { "code": "poco_x6_5g", "name": "Poco X6 5G" },
  { "code": "poco_x6_prp_5g", "name": "Poco X6 PRP 5G" },
  { "code": "poco_x7_5g", "name": "Poco X7 5G" },
  
  { "code": "redmi_9c", "name": "Redmi 9C" },
  { "code": "redmi_10_5g", "name": "Redmi 10 5G" },
  { "code": "redmi_10_power", "name": "Redmi 10 Power" },
  { "code": "redmi_10a_sport", "name": "Redmi 10A Sport" },
  { "code": "redmi_11_prime", "name": "Redmi 11 Prime" },
  { "code": "redmi_12_4g", "name": "Redmi 12 4G" },
  { "code": "redmi_12_5g", "name": "Redmi 12 5G" },
  { "code": "redmi_12c", "name": "Redmi 12C" },
  { "code": "redmi_13_5g", "name": "Redmi 13 5G" },
  { "code": "redmi_13c_5g", "name": "Redmi 13C 5G" },
  { "code": "redmi_14c", "name": "Redmi 14C" },
  { "code": "redmi_14c_5g", "name": "Redmi 14C 5G" },
  { "code": "redmi_a1_plus", "name": "Redmi A1 Plus" },
  { "code": "redmi_a2", "name": "Redmi A2" },
  { "code": "redmi_a3", "name": "Redmi A3" },
  { "code": "redmi_a3x", "name": "Redmi A3X" },
  { "code": "redmi_a4_5g", "name": "Redmi A4 5G" },
  { "code": "redmi_a5", "name": "Redmi A5" },

  { "code": "redmi_k40_gaming", "name": "Redmi K40 Gaming" },

  { "code": "redmi_note_8", "name": "Redmi Note 8" },
  { "code": "redmi_note_10_pro_max", "name": "Redmi Note 10 Pro Max" },
  { "code": "redmi_note_12_4g", "name": "Redmi Note 12 4G" },
  { "code": "redmi_note_12_5g", "name": "Redmi Note 12 5G" },
  { "code": "redmi_note_12_pro_5g", "name": "Redmi Note 12 Pro 5G" },
  { "code": "redmi_note_12_pro_plus_5g", "name": "Redmi Note 12 Pro Plus 5G" },
  { "code": "redmi_note_13_4g", "name": "Redmi Note 13 4G" },
  { "code": "redmi_note_13_5g", "name": "Redmi Note 13 5G" },
  { "code": "redmi_note_13_prp_plus_5g", "name": "Redmi Note 13 PRP Plus 5G" },
  { "code": "redmi_note_13_pro_5g", "name": "Redmi Note 13 Pro 5G" },
  { "code": "redmi_note_14_4g", "name": "Redmi Note 14 4G" },
  { "code": "redmi_note_14_pro_4g", "name": "Redmi Note 14 Pro 4G" },
  { "code": "redmi_note_14_pro_5g", "name": "Redmi Note 14 Pro 5G" },
  { "code": "redmi_note_14_pro_plus_5g", "name": "Redmi Note 14 Pro Plus 5G" },

  { "code": "xiaomi_11t", "name": "Xiaomi 11T" },
  { "code": "xiaomi_11i_hypercharge_5g", "name": "Xiaomi 11i Hypercharge 5G" },
  { "code": "xiaomi_11i_5g", "name": "Xiaomi 11i 5G" },
  { "code": "xiaomi_12x", "name": "Xiaomi 12X" },
  { "code": "xiaomi_12_pro", "name": "Xiaomi 12 Pro" },
  { "code": "xiaomi_13_pro_5g", "name": "Xiaomi 13 Pro 5G" },
  { "code": "xiaomi_14_5g", "name": "Xiaomi 14 5G" },
  { "code": "xiaomi_15_5g", "name": "Xiaomi 15 5G" },
  { "code": "redmi_14t_pro_5g", "name": "Redmi 14T Pro 5G" },

  { "code": "mi_10", "name": "Mi 10" },
  { "code": "mi_11_5g", "name": "Mi 11 5G" }
],
"Google": [
  { "code": "pixel_3a", "name": "Pixel 3A" },
  { "code": "pixel_3xl", "name": "Pixel 3XL" },
  { "code": "pixel_4", "name": "Pixel 4" },
  { "code": "pixel_4a", "name": "Pixel 4A" },
  { "code": "pixel_4xl", "name": "Pixel 4XL" },
  { "code": "pixel_5", "name": "Pixel 5" },
  { "code": "pixel_5a", "name": "Pixel 5A" },
  { "code": "pixel_6", "name": "Pixel 6" },
  { "code": "pixel_6a", "name": "Pixel 6A" },
  { "code": "pixel_6_pro_5g", "name": "Pixel 6 Pro 5G" },
  { "code": "pixel_7", "name": "Pixel 7" },
  { "code": "pixel_7a", "name": "Pixel 7A" },
  { "code": "pixel_7_pro", "name": "Pixel 7 Pro" },
  { "code": "pixel_8", "name": "Pixel 8" },
  { "code": "pixel_8a", "name": "Pixel 8A" },
  { "code": "pixel_8_pro", "name": "Pixel 8 Pro" },
  { "code": "pixel_9", "name": "Pixel 9" },
  { "code": "pixel_9a", "name": "Pixel 9A" },
  { "code": "pixel_9_pro", "name": "Pixel 9 Pro" },
  { "code": "pixel_9_pro_fold_5g", "name": "Pixel 9 Pro Fold 5G" },
  { "code": "pixel_9_pro_xl", "name": "Pixel 9 Pro XL" },
  { "code": "pixel_fold", "name": "Pixel Fold" }
],
"Oppo":[
  {
    "code": "a3_5g",
    "name": "A3 5g"
  },
  {
    "code": "a3_pro_5g",
    "name": "A3 Pro 5g"
  },
  {
    "code": "a3x_4g",
    "name": "A3x 4g"
  },
  {
    "code": "a3x_5g",
    "name": "A3x 5g"
  },
  {
    "code": "a5_2020",
    "name": "A5 2020"
  },
  {
    "code": "a5_pro",
    "name": "A5 Pro"
  },
  {
    "code": "a5s",
    "name": "A5s"
  },
  {
    "code": "a9",
    "name": "A9"
  },
  {
    "code": "a9_2020",
    "name": "A9 2020"
  },
  {
    "code": "a11k",
    "name": "A11k"
  },
  {
    "code": "a12",
    "name": "A12"
  },
  {
    "code": "a15",
    "name": "A15"
  },
  {
    "code": "a15s",
    "name": "A15s"
  },
  {
    "code": "a16",
    "name": "A16"
  },
  {
    "code": "a16e",
    "name": "A16e"
  },
  {
    "code": "a16k",
    "name": "A16k"
  },
  {
    "code": "a17",
    "name": "A17"
  },
  {
    "code": "a17_k",
    "name": "A17 K"
  },
  {
    "code": "a18",
    "name": "A18"
  },
  {
    "code": "a31",
    "name": "A31"
  },
  {
    "code": "a33",
    "name": "A33"
  },
  {
    "code": "a38",
    "name": "A38"
  },
  {
    "code": "a52",
    "name": "A52"
  },
  {
    "code": "a53",
    "name": "A53"
  },
  {
    "code": "a53s_5g",
    "name": "A53s 5g"
  },
  {
    "code": "a54",
    "name": "A54"
  },
  {
    "code": "a55",
    "name": "A55"
  },
  {
    "code": "a57_4g",
    "name": "A57 4g"
  },
  {
    "code": "a57_5g",
    "name": "A57 5g"
  },
  {
    "code": "a58_4g",
    "name": "A58 4g"
  },
  {
    "code": "a58_5g",
    "name": "A58 5g"
  },
  {
    "code": "a59_5g",
    "name": "A59 5g"
  },
  {
    "code": "a60",
    "name": "A60"
  },
  {
    "code": "a71",
    "name": "A71"
  },
  {
    "code": "a73",
    "name": "A73"
  },
  {
    "code": "a74_5g",
    "name": "A74 5g"
  },
  {
    "code": "a76",
    "name": "A76"
  },
  {
    "code": "a77_4g",
    "name": "A77 4g"
  },
  {
    "code": "a77s",
    "name": "A77s"
  },
  {
    "code": "a78_4g",
    "name": "A78 4g"
  },
  {
    "code": "a78_5g",
    "name": "A78 5g"
  },
  {
    "code": "a79_5g",
    "name": "A79 5g"
  },
  {
    "code": "a91",
    "name": "A91"
  },
  {
    "code": "a92",
    "name": "A92"
  },
  {
    "code": "a93",
    "name": "A93"
  },
  {
    "code": "a94",
    "name": "A94"
  },
  {
    "code": "a95_5g",
    "name": "A95 5g"
  },
  {
    "code": "a96",
    "name": "A96"
  },
  {
    "code": "c15",
    "name": "C15"
  },
  {
    "code": "f5",
    "name": "F5"
  },
  {
    "code": "f9_pro",
    "name": "F9 Pro"
  },
  {
    "code": "f11",
    "name": "F11"
  },
  {
    "code": "f11_pro",
    "name": "F11 Pro"
  },
  {
    "code": "f15",
    "name": "F15"
  },
  {
    "code": "f17",
    "name": "F17"
  },
  {
    "code": "f17_pro",
    "name": "F17 Pro"
  },
  {
    "code": "f19",
    "name": "F19"
  },
  {
    "code": "f19_pro",
    "name": "F19 Pro"
  },
  {
    "code": "f19_pro_plus",
    "name": "F19 Pro Plus"
  },
  {
    "code": "f19s",
    "name": "F19s"
  },
  {
    "code": "f21_pro_4g",
    "name": "F21 Pro 4g"
  },
  {
    "code": "f21_pro_5g",
    "name": "F21 Pro 5g"
  },
  {
    "code": "f21s_pro",
    "name": "F21s Pro"
  },
  {
    "code": "f21s_pro_5g",
    "name": "F21s Pro 5g"
  },
  {
    "code": "f23_5g",
    "name": "F23 5g"
  },
  {
    "code": "f25_pro_5g",
    "name": "F25 Pro 5g"
  },
  {
    "code": "f27_5g",
    "name": "F27 5g"
  },
  {
    "code": "f27_pro_plus_5g",
    "name": "F27 Pro Plus 5g"
  },
  {
    "code": "f29_5g",
    "name": "F29 5g"
  },
  {
    "code": "f29_pro_5g",
    "name": "F29 Pro 5g"
  },
  {
    "code": "find_n2_5g",
    "name": "Find N2 5g"
  },
  {
    "code": "find_n2_flip_5g",
    "name": "Find N2 Flip 5g"
  },
  {
    "code": "find_n3_flip_5g",
    "name": "Find N3 Flip 5g"
  },
  {
    "code": "find_x",
    "name": "Find X"
  },
  {
    "code": "find_x2",
    "name": "Find X2"
  },
  {
    "code": "find_x5_pro_5g",
    "name": "Find X5 Pro 5g"
  },
  {
    "code": "find_x8_5g",
    "name": "Find X8 5g"
  },
  {
    "code": "find_x8_pro_5g",
    "name": "Find X8 Pro 5g"
  },
  {
    "code": "k1",
    "name": "K1"
  },
  {
    "code": "k3",
    "name": "K3"
  },
  {
    "code": "k10",
    "name": "K10"
  },
  {
    "code": "k10_5g",
    "name": "K10 5g"
  },
  {
    "code": "k12x_5g",
    "name": "K12x 5g"
  },
  {
    "code": "k13_5g",
    "name": "K13 5g"
  },
  {
    "code": "narzo_10",
    "name": "Narzo 10"
  },
  {
    "code": "narzo_10a",
    "name": "Narzo 10a"
  },
  {
    "code": "narzo_20a",
    "name": "Narzo 20a"
  },
  {
    "code": "narzo_30_pro_5g",
    "name": "Narzo 30 Pro 5g"
  },
  {
    "code": "narzo_30a",
    "name": "Narzo 30a"
  },
  {
    "code": "narzo_50a",
    "name": "Narzo 50a"
  },
  {
    "code": "r15_pro",
    "name": "R15 Pro"
  },
  {
    "code": "r17",
    "name": "R17"
  },
  {
    "code": "r17_pro",
    "name": "R17 Pro"
  },
  {
    "code": "realm_u1",
    "name": "Realm U1"
  },
  {
    "code": "realem",
    "name": "Realem"
  },
  {
    "code": "realem_9_5g_se",
    "name": "Realem 9 5g Se"
  },
  {
    "code": "realme",
    "name": "Realme"
  },
  {
    "code": "realme_2",
    "name": "Realme 2"
  },
  {
    "code": "realme_3",
    "name": "Realme 3"
  },
  {
    "code": "realme_3_pro",
    "name": "Realme 3 Pro"
  },
  {
    "code": "realme_3i",
    "name": "Realme 3i"
  },
  {
    "code": "realme_5",
    "name": "Realme 5"
  },
  {
    "code": "realme_5_pro",
    "name": "Realme 5 Pro"
  },
  {
    "code": "realme_5i",
    "name": "Realme 5i"
  },
  {
    "code": "realme_5s",
    "name": "Realme 5s"
  },
  {
    "code": "realme_6",
    "name": "Realme 6"
  },
  {
    "code": "realme_6_pro",
    "name": "Realme 6 Pro"
  },
  {
    "code": "realme_6i",
    "name": "Realme 6i"
  },
  {
    "code": "realme_7",
    "name": "Realme 7"
  },
  {
    "code": "realme_7_pro",
    "name": "Realme 7 Pro"
  },
  {
    "code": "realme_7i",
    "name": "Realme 7i"
  },
  {
    "code": "realme_8",
    "name": "Realme 8"
  },
  {
    "code": "realme_8_5g",
    "name": "Realme 8 5g"
  },
  {
    "code": "realme_8_pro",
    "name": "Realme 8 Pro"
  },
  {
    "code": "realme_8i",
    "name": "Realme 8i"
  },
  {
    "code": "realme_8s_5g",
    "name": "Realme 8s 5g"
  },
  {
    "code": "realme_9",
    "name": "Realme 9"
  },
  {
    "code": "realme_9_5g",
    "name": "Realme 9 5g"
  },
  {
    "code": "realme_9_pro_5g",
    "name": "Realme 9 Pro 5g"
  },
  {
    "code": "realme_9_pro_plus",
    "name": "Realme 9 Pro Plus"
  },
  {
    "code": "realme_9i",
    "name": "Realme 9i"
  },
  {
    "code": "realme_9i_5g",
    "name": "Realme 9i 5g"
  },
  {
    "code": "realme_c1",
    "name": "Realme C1"
  },
  {
    "code": "realme_c2",
    "name": "Realme C2"
  },
  {
    "code": "realme_c3",
    "name": "Realme C3"
  },
  {
    "code": "realme_c11",
    "name": "Realme C11"
  },
  {
    "code": "realme_c11_2021",
    "name": "Realme C11 2021"
  },
  {
    "code": "realme_c12",
    "name": "Realme C12"
  },
  {
    "code": "realme_c21y",
    "name": "Realme C21y"
  },
  {
    "code": "realme_c25s",
    "name": "Realme C25s"
  },
  {
    "code": "realme_c25y",
    "name": "Realme C25y"
  },
  {
    "code": "realme_c30",
    "name": "Realme C30"
  },
  {
    "code": "realme_c31",
    "name": "Realme C31"
  },
  {
    "code": "realme_c33",
    "name": "Realme C33"
  },
  {
    "code": "realme_c35",
    "name": "Realme C35"
  },
  {
    "code": "realme_gt_2_pro",
    "name": "Realme Gt 2 Pro"
  },
  {
    "code": "realme_gt_5g",
    "name": "Realme Gt 5g"
  },
  {
    "code": "realme_gt_grand_master_edition",
    "name": "Realme Gt Grand Master Edition"
  },
  {
    "code": "realme_gt_master_edition",
    "name": "Realme Gt Master Edition"
  },
  {
    "code": "realme_gt_neo_2_5g",
    "name": "Realme Gt Neo 2 5g"
  },
  {
    "code": "realme_gt_neo_3_5g",
    "name": "Realme Gt Neo 3 5g"
  },
  {
    "code": "realme_gt_neo_3t_5g",
    "name": "Realme Gt Neo 3t 5g"
  },
  {
    "code": "realme_gt2_5g",
    "name": "Realme Gt2 5g"
  },
  {
    "code": "realme_narzo_20",
    "name": "Realme Narzo 20"
  },
  {
    "code": "realme_narzo_20_pro",
    "name": "Realme Narzo 20 Pro"
  },
  {
    "code": "realme_narzo_30",
    "name": "Realme Narzo 30"
  },
  {
    "code": "realme_narzo_30_5g",
    "name": "Realme Narzo 30 5g"
  },
  {
    "code": "realme_narzo_50",
    "name": "Realme Narzo 50"
  },
  {
    "code": "realme_narzo_50_5g",
    "name": "Realme Narzo 50 5g"
  },
  {
    "code": "realme_narzo_50_a_prime",
    "name": "Realme Narzo 50 A Prime"
  },
  {
    "code": "realme_narzo_50_pro_5g",
    "name": "Realme Narzo 50 Pro 5g"
  },
  {
    "code": "realme_narzo_50a_prime",
    "name": "Realme Narzo 50a Prime"
  },
  {
    "code": "realme_narzo_50i",
    "name": "Realme Narzo 50i"
  },
  {
    "code": "realme_x",
    "name": "Realme X"
  },
  {
    "code": "realme_x2",
    "name": "Realme X2"
  },
  {
    "code": "realme_x2_pro",
    "name": "Realme X2 Pro"
  },
  {
    "code": "realme_x3",
    "name": "Realme X3"
  },
  {
    "code": "realme_x3_superzoom",
    "name": "Realme X3 Superzoom"
  },
  {
    "code": "realme_x50_pro",
    "name": "Realme X50 Pro"
  },
  {
    "code": "realme_x50_pro_5g",
    "name": "Realme X50 Pro 5g"
  },
  {
    "code": "realme_x7",
    "name": "Realme X7"
  },
  {
    "code": "realme_x7_max_5g",
    "name": "Realme X7 Max 5g"
  },
  {
    "code": "realme_x7_pro",
    "name": "Realme X7 Pro"
  },
  {
    "code": "realme_xt",
    "name": "Realme Xt"
  },
  {
    "code": "reno",
    "name": "Reno"
  },
  {
    "code": "reno_2",
    "name": "Reno 2"
  },
  {
    "code": "reno_2_f",
    "name": "Reno 2 F"
  },
  {
    "code": "reno_2_z",
    "name": "Reno 2 Z"
  },
  {
    "code": "reno_3",
    "name": "Reno 3"
  },
  {
    "code": "reno_3_pro",
    "name": "Reno 3 Pro"
  },
  {
    "code": "reno_4",
    "name": "Reno 4"
  },
  {
    "code": "reno_4_pro",
    "name": "Reno 4 Pro"
  },
  {
    "code": "reno_5_4g",
    "name": "Reno 5 4g"
  },
  {
    "code": "reno_5_5g",
    "name": "Reno 5 5g"
  },
  {
    "code": "reno_5_lite",
    "name": "Reno 5 Lite"
  },
  {
    "code": "reno_5_pro",
    "name": "Reno 5 Pro"
  },
  {
    "code": "reno_5z_5g",
    "name": "Reno 5z 5g"
  },
  {
    "code": "reno_6",
    "name": "Reno 6"
  },
  {
    "code": "reno_6_pro_5g",
    "name": "Reno 6 Pro 5g"
  },
  {
    "code": "reno_6z_5g",
    "name": "Reno 6z 5g"
  },
  {
    "code": "reno_7_5g",
    "name": "Reno 7 5g"
  },
  {
    "code": "reno_7_pro_5g",
    "name": "Reno 7 Pro 5g"
  },
  {
    "code": "reno_8_5g",
    "name": "Reno 8 5g"
  },
  {
    "code": "reno_8_pro_5g",
    "name": "Reno 8 Pro 5g"
  },
  {
    "code": "reno_8t_4g",
    "name": "Reno 8t 4g"
  },
  {
    "code": "reno_8t_5g",
    "name": "Reno 8t 5g"
  },
  {
    "code": "reno_10_5g",
    "name": "Reno 10 5g"
  },
  {
    "code": "reno_10_pro",
    "name": "Reno 10 Pro"
  },
  {
    "code": "reno_10_pro_plus_5g",
    "name": "Reno 10 Pro Plus 5g"
  },
  {
    "code": "reno_10x_zoom",
    "name": "Reno 10x Zoom"
  },
  {
    "code": "reno_11_5g",
    "name": "Reno 11 5g"
  },
  {
    "code": "reno_11_pro_5g",
    "name": "Reno 11 Pro 5g"
  },
  {
    "code": "reno_11f_5g",
    "name": "Reno 11f 5g"
  },
  {
    "code": "reno_12_5g",
    "name": "Reno 12 5g"
  },
  {
    "code": "reno_12_f",
    "name": "Reno 12 F"
  },
  {
    "code": "reno_12_pro_5g",
    "name": "Reno 12 Pro 5g"
  },
  {
    "code": "reno_13_5g",
    "name": "Reno 13 5g"
  },
  {
    "code": "reno_13_pro_5g",
    "name": "Reno 13 Pro 5g"
  }
],
"Vivo":[
  {"code": "1901y15_2019", "name": "1901y15 2019"},
  {"code": "1902_y17", "name": "1902 Y17"},
  {"code": "1906y11", "name": "1906y11"},
  {"code": "1907_s1", "name": "1907 S1"},
  {"code": "1916u10", "name": "1916u10"},
  {"code": "1938y30", "name": "1938y30"},
  {"code": "iqoo_11_5g", "name": "Iqoo 11 5g"},
  {"code": "iqoo_12_5g", "name": "Iqoo 12 5g"},
  {"code": "iqoo_35g", "name": "Iqoo 35g"},
  {"code": "iqoo_7_5g", "name": "Iqoo 7 5g"},
  {"code": "iqoo_7_legend", "name": "Iqoo 7 Legend"},
  {"code": "iqoo_7_legend_5g", "name": "Iqoo 7 Legend 5g"},
  {"code": "iqoo_9_5g", "name": "Iqoo 9 5g"},
  {"code": "iqoo_9_pro_5g", "name": "Iqoo 9 Pro 5g"},
  {"code": "iqoo_9_se_5g", "name": "Iqoo 9 Se 5g"},
  {"code": "iqoo_9t_5g", "name": "Iqoo 9t 5g"},
  {"code": "iqoo_neo_3", "name": "Iqoo Neo 3"},
  {"code": "iqoo_neo_6_5g", "name": "Iqoo Neo 6 5g"},
  {"code": "iqoo_neo_7_5g", "name": "Iqoo Neo 7 5g"},
  {"code": "iqoo_neo_7_pro_5g", "name": "Iqoo Neo 7 Pro 5g"},
  {"code": "iqoo_neo_9_pro_5g", "name": "Iqoo Neo 9 Pro 5g"},
  {"code": "iqoo_z3_5g", "name": "Iqoo Z3 5g"},
  {"code": "iqoo_z5_5g", "name": "Iqoo Z5 5g"},
  {"code": "iqoo_z6", "name": "Iqoo Z6"},
  {"code": "iqoo_z6_5g", "name": "Iqoo Z6 5g"},
  {"code": "iqoo_z6_lite_5g", "name": "Iqoo Z6 Lite 5g"},
  {"code": "iqoo_z6_pro_5g", "name": "Iqoo Z6 Pro 5g"},
  {"code": "iqoo_z7_5g", "name": "Iqoo Z7 5g"},
  {"code": "iqoo_z7_pro__5g", "name": "Iqoo Z7 Pro  5g"},
  {"code": "iqoo_z7s_5g", "name": "Iqoo Z7s 5g"},
  {"code": "iqoo_z9_5g", "name": "Iqoo Z9 5g"},
  {"code": "nex_3", "name": "Nex 3"},
  {"code": "nex_a", "name": "Nex A"},
  {"code": "nex_s", "name": "Nex S"},
  {"code": "s1_pro", "name": "S1 Pro"},
  {"code": "t1", "name": "T1"},
  {"code": "t1_5g", "name": "T1 5g"},
  {"code": "t1_pro_5g", "name": "T1 Pro 5g"},
  {"code": "t1x", "name": "T1x"},
  {"code": "t2_5g", "name": "T2 5g"},
  {"code": "t2_pro__5g", "name": "T2 Pro  5g"},
  {"code": "t2x_5g", "name": "T2x 5g"},
  {"code": "t3_5g", "name": "T3 5g"},
  {"code": "u20", "name": "U20"},
  {"code": "v11", "name": "V11"},
  {"code": "v11_pro", "name": "V11 Pro"},
  {"code": "v15", "name": "V15"},
  {"code": "v15_pro", "name": "V15 Pro"},
  {"code": "v17", "name": "V17"},
  {"code": "v17_pro", "name": "V17 Pro"},
  {"code": "v19", "name": "V19"},
  {"code": "v20", "name": "V20"},
  {"code": "v20_pro", "name": "V20 Pro"},
  {"code": "v20_se_v_2022", "name": "V20 Se V 2022"},
  {"code": "v21", "name": "V21"},
  {"code": "v21e", "name": "V21e"},
  {"code": "v21e_5g", "name": "V21e 5g"},
  {"code": "v23_5g", "name": "V23 5g"},
  {"code": "v23_pro_5g", "name": "V23 Pro 5g"},
  {"code": "v23e_5g", "name": "V23e 5g"},
  {"code": "v25_5g", "name": "V25 5g"},
  {"code": "v25_pro_5g", "name": "V25 Pro 5g"},
  {"code": "v27_5g", "name": "V27 5g"},
  {"code": "v27_pro_5g", "name": "V27 Pro 5g"},
  {"code": "v27e", "name": "V27e"},
  {"code": "v29_5g", "name": "V29 5g"},
  {"code": "v29_pro_5g", "name": "V29 Pro 5g"},
  {"code": "v29e_5g", "name": "V29e 5g"},
  {"code": "v30", "name": "V30"},
  {"code": "v30_pro_5g", "name": "V30 Pro 5g"},
  {"code": "v3", "name": "V3"},
  {"code": "v5", "name": "V5"},
  {"code": "v5_plus", "name": "V5 Plus"},
  {"code": "v5s", "name": "V5s"},
  {"code": "v7_plus", "name": "V7 Plus"},
  {"code": "v9", "name": "V9"},
  {"code": "v9_pro", "name": "V9 Pro"},
  {"code": "v9_youth", "name": "V9 Youth"},
  {"code": "x100_5g", "name": "X100 5g"},
  {"code": "x50", "name": "X50"},
  {"code": "x50_pro", "name": "X50 Pro"},
  {"code": "x60", "name": "X60"},
  {"code": "x60_pro", "name": "X60 Pro"},
  {"code": "x60_pro_plus", "name": "X60 Pro Plus"},
  {"code": "x70_pro", "name": "X70 Pro"},
  {"code": "x70_pro_plus5g", "name": "X70 Pro Plus5g"},
  {"code": "x80_5g", "name": "X80 5g"},
  {"code": "x80_pro_5g", "name": "X80 Pro 5g"},
  {"code": "x9", "name": "X9"},
  {"code": "x90", "name": "X90"},
  {"code": "x90_pro", "name": "X90 Pro"},
  {"code": "x21", "name": "X21"},
  {"code": "y01", "name": "Y01"},
  {"code": "y02", "name": "Y02"},
  {"code": "y11", "name": "Y11"},
  {"code": "y12", "name": "Y12"},
  {"code": "y12a", "name": "Y12a"},
  {"code": "y12g", "name": "Y12g"},
  {"code": "y12s", "name": "Y12s"},
  {"code": "y15c", "name": "Y15c"},
  {"code": "y15s", "name": "Y15s"},
  {"code": "y16", "name": "Y16"},
  {"code": "y17s", "name": "Y17s"},
  {"code": "y18", "name": "Y18"},
  {"code": "y19", "name": "Y19"},
  {"code": "y20", "name": "Y20"},
  {"code": "y20a", "name": "Y20a"},
  {"code": "y20g", "name": "Y20g"},
  {"code": "y20i", "name": "Y20i"},
  {"code": "y20s", "name": "Y20s"},
  {"code": "y20t", "name": "Y20t"},
  {"code": "y21_2021", "name": "Y21 2021"},
  {"code": "y21e", "name": "Y21e"},
  {"code": "y21g", "name": "Y21g"},
  {"code": "y21t", "name": "Y21t"},
  {"code": "y22_2022", "name": "Y22 2022"},
  {"code": "y27_4g_2023", "name": "Y27 4g 2023"},
  {"code": "y28_5g", "name": "Y28 5g"},
  {"code": "y28s_5g", "name": "Y28s 5g"},
  {"code": "y28e", "name": "Y28e"},
  {"code": "y29_5g", "name": "Y29 5g"},
  {"code": "y30", "name": "Y30"},
  {"code": "y31", "name": "Y31"},
  {"code": "y31_2021", "name": "Y31 2021"},
  {"code": "y33s", "name": "Y33s"},
  {"code": "y33t", "name": "Y33t"},
  {"code": "y35_2022", "name": "Y35 2022"},
  {"code": "y352022", "name": "Y352022"},
  {"code": "y36", "name": "Y36"},
  {"code": "y50", "name": "Y50"},
  {"code": "y51", "name": "Y51"},
  {"code": "y51a", "name": "Y51a"},
  {"code": "y53s", "name": "Y53s"},
  {"code": "y53s_2021", "name": "Y53s 2021"},
  {"code": "y55", "name": "Y55"},
  {"code": "y55_2022", "name": "Y55 2022"},
  {"code": "y55l", "name": "Y55l"},
  {"code": "y56_5g", "name": "Y56 5g"},
  {"code": "y66", "name": "Y66"},
  {"code": "y69", "name": "Y69"},
  {"code": "y71", "name": "Y71"},
  {"code": "y72_5g", "name": "Y72 5g"},
  {"code": "y73", "name": "Y73"},
  {"code": "y75", "name": "Y75"},
  {"code": "y75_5g", "name": "Y75 5g"},
  {"code": "y76_5g", "name": "Y76 5g"},
  {"code": "y81", "name": "Y81"},
  {"code": "y81i", "name": "Y81i"},
  {"code": "y83", "name": "Y83"},
  {"code": "y83_pro", "name": "Y83 Pro"},
  {"code": "y85", "name": "Y85"},
  {"code": "y91", "name": "Y91"},
  {"code": "y91i", "name": "Y91i"},
  {"code": "y93", "name": "Y93"},
  {"code": "y95", "name": "Y95"},
  {"code": "y100", "name": "Y100"},
  {"code": "y100_5g", "name": "Y100 5g"},
  {"code": "y200_5g", "name": "Y200 5g"},
  {"code": "y200e_5g", "name": "Y200e 5g"},
  {"code": "y300_5g", "name": "Y300 5g"},
  {"code": "yo2t", "name": "Yo2t"},
  {"code": "z1_pro", "name": "Z1 Pro"},
  {"code": "z1x", "name": "Z1x"},
  {"code": "z10", "name": "Z10"},
  {"code": "z9s", "name": "Z9s"},
  {"code": "z9s_pro_5g", "name": "Z9s Pro 5g"}
],
"Motorola":[
  { "code": "motorola_edge_20_fusion", "name": "Motorola Edge 20 Fusion" },
  { "code": "motorola_edge_20_pro_5g", "name": "Motorola Edge 20 Pro 5G" },
  { "code": "motorola_edge_30", "name": "Motorola Edge 30" },
  { "code": "motorola_edge_30_fusion", "name": "Motorola Edge 30 Fusion" },
  { "code": "motorola_edge_30_pro", "name": "Motorola Edge 30 Pro" },
  { "code": "motorola_edge_30_ultra", "name": "Motorola Edge 30 Ultra" },
  { "code": "motorola_edge_40_5g", "name": "Motorola Edge 40 5G" },
  { "code": "motorola_edge_40_pro_5g", "name": "Motorola Edge 40 Pro 5G" },
  { "code": "motorola_edge_50_5g", "name": "Motorola Edge 50 5G" },
  { "code": "motorola_edge_50_fusion_5g", "name": "Motorola Edge 50 Fusion 5G" },
  { "code": "motorola_edge_50_neo", "name": "Motorola Edge 50 Neo" },
  { "code": "motorola_edge_50_pro", "name": "Motorola Edge 50 Pro" },
  { "code": "motorola_edge_50_ultra_5g", "name": "Motorola Edge 50 Ultra 5G" },
  { "code": "motorola_edge_60", "name": "Motorola Edge 60" },
  { "code": "motorola_edge_x30_5g", "name": "Motorola Edge X30 5G" },
  { "code": "motorola_g32", "name": "Motorola G32" },
  { "code": "motorola_g34_5g", "name": "Motorola G34 5G" },
  { "code": "motorola_g42", "name": "Motorola G42" },
  { "code": "motorola_g45_5g", "name": "Motorola G45 5G" },
  { "code": "motorola_g54_5g", "name": "Motorola G54 5G" },
  { "code": "motorola_g62_5g", "name": "Motorola G62 5G" },
  { "code": "motorola_g73_5g", "name": "Motorola G73 5G" },
  { "code": "motorola_g82_5g", "name": "Motorola G82 5G" },
  { "code": "motorola_g84_5g", "name": "Motorola G84 5G" },
  { "code": "motorola_g85_5g", "name": "Motorola G85 5G" },
  { "code": "motorola_g9_power", "name": "Motorola G9 Power" },
  { "code": "motorola_g_power_2022", "name": "Motorola G Power (2022)" },
  { "code": "motorola_razr_40_5g", "name": "Motorola Razr 40 5G" },
  { "code": "motorola_razr_40_ultra_5g", "name": "Motorola Razr 40 Ultra 5G" },
  { "code": "motorola_razr_50_ultra", "name": "Motorola Razr 50 Ultra" },
  { "code": "motorola_x40", "name": "Motorola X40" },
  { "code": "motorola_x60_fusion", "name": "Motorola X60 Fusion" },
  { "code": "motorola_40_neo_5g", "name": "Motorola 40 Neo 5G" }
],
"Nothing":[
    { "code": "nothing_phone_1", "name": "Nothing Phone (1)" },
    { "code": "nothing_phone_2", "name": "Nothing Phone (2)" },
    { "code": "nothing_phone_2a", "name": "Nothing Phone (2a)" },
    { "code": "nothing_phone_3a", "name": "Nothing Phone (3a)" },
    { "code": "nothing_phone_3a_pro", "name": "Nothing Phone (3a Pro)" },
    { "code": "nothing_cmf_1_5g", "name": "Nothing CMF Phone 1 5G" }
  ]
})
  .map(([key, value]) => [key, value.reverse()])
);

window.brandModelData = brandModelData;